import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

import JourneyMap from './components/JourneyMap.svelte';

const mapContainer = findElementByIdInShadowDom('journey-map');

renderSvelteComponent(JourneyMap, /** @type {HTMLElement} */ mapContainer);

const leftBtn = document.getElementById('left-scroll');
const rightBtn = findElementByIdInShadowDom('right-scroll');

// Scroll right by 300px
rightBtn.addEventListener('click', () => {
  mapContainer.scrollBy({ left: 300, behavior: 'smooth' });
});

// Scroll left by 300px
leftBtn.addEventListener('click', () => {
  mapContainer.scrollBy({ left: -300, behavior: 'smooth' });
});
